import { render } from "./App.vue?vue&type=template&id=6eb27068"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6eb27068&lang=scss"

import exportComponent from "D:\\Allgemein\\Ich\\Hobbys\\Programmieren\\Web Development\\little-projects\\vue-test-router\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__